import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ScrollToTop, CookieBanner } from "./components/Common";
import Home from "./pages/Home";
import WhatWeDo from "./pages/WhatWeDo";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ServicePage from "./pages/ServicePage";
import Hipaa from "./pages/Hipaa";
import Jobs from "./pages/Jobs";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Policies from "./pages/Policies";
import Admin from "./pages/Admin";
import OurBrands from "./pages/OurBrands";

const serviceSlugs = [
  "for-hospitals",
  "for-doctors",
  "for-orthodontists",
  "for-insurance-companies",
  "for-attorneys",
  "for-contractors",
  "debt-collection-services",
  "leads-on-demand",
  "b2b-sales-meetings",
];

const ServiceRoute = () => {
  const { slug } = useParams();
  return <ServicePage slug={slug} />;
};

const Layout = () => {
  const location = useLocation();
  return (
    <>
      <ScrollToTop pathname={location.pathname} />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/hipaa" element={<Hipaa />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/our-brands" element={<OurBrands />} />
          {serviceSlugs.map((s) => (
            <Route key={s} path={`/${s}`} element={<ServicePage slug={s} />} />
          ))}
          <Route path="/services/:slug" element={<ServiceRoute />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}

export default App;
